(function () {
  // Only run for product-page accordions
  var GROUP_SELECTOR = '.product__info-container';

  function getProductGroup(el) {
    // Find the product info column that contains this <details>
    return (el.closest && el.closest(GROUP_SELECTOR)) || null;
  }

  function closeOthersInGroup(group, keep) {
    if (!group) return;
    // Only touch details that live inside .product__accordion wrappers
    var open = group.querySelectorAll('.product__accordion details[open]');
    for (var i = 0; i < open.length; i++) {
      if (open[i] !== keep) open[i].removeAttribute('open');
    }
  }

  // When one opens, close the others in the same product info column
  document.addEventListener('toggle', function (e) {
    var item = e.target;
    if (!item || item.tagName !== 'DETAILS' || !item.open) return;
    // Only act if this details is in a .product__accordion block
    if (!item.closest || !item.closest('.product__accordion')) return;

    var group = getProductGroup(item);
    // opt-out: allow multiple by adding .product-acc-allow-multi to the column
    if (group && group.classList.contains('product-acc-allow-multi')) return;

    closeOthersInGroup(group, item);
  }, true);

  // On load, keep only the first open per product column
  function normalize() {
    var groups = document.querySelectorAll(GROUP_SELECTOR);
    for (var g = 0; g < groups.length; g++) {
      if (groups[g].classList.contains('product-acc-allow-multi')) continue;
      var opened = groups[g].querySelectorAll('.product__accordion details[open]');
      for (var i = 1; i < opened.length; i++) opened[i].removeAttribute('open');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalize);
  } else {
    normalize();
  }
})();
